import { Action } from '@ngrx/store';

export enum TimerActionTypes {
  INIT = '[Order builder timer] Set default timer values',
  RESTART = '[Order builder timer] Restart default timer values',
  WARNING = '[Order builder timer] Timeout warning',
  END = '[Order builder timer] Timeout time set to null',
  SET_TIMER = '[Order builder timer] Set timer value',
}

export class TimerStartAction implements Action {
  readonly type = TimerActionTypes.INIT;
  constructor(public timeRemaining, public warnings: number[]) {}
}

export class TimerRestartAction implements Action {
  readonly type = TimerActionTypes.RESTART;
  constructor() {}
}

export class TimerWarningAction implements Action {
  readonly type = TimerActionTypes.WARNING;
  constructor(public payload: number = 0) {}
}

export class TimerCloseAction implements Action {
  readonly type = TimerActionTypes.END;
  constructor(public payload: { restart: boolean }) {}
}

export class TimerSetAction implements Action {
  readonly type = TimerActionTypes.SET_TIMER;
  constructor(public payload: { time: number }) {}
}

export type TimerActions =
  | TimerStartAction
  | TimerRestartAction
  | TimerWarningAction
  | TimerCloseAction
  | TimerSetAction;
